import api, { listData } from "../api/client";

export const commerceService = {
  async dashboard(params = {}) { return (await api.get("/ventas/dashboard/", { params })).data; },
  async sales(params) { return (await api.get("/ventas/", { params })).data; },
  async products(params) { return listData((await api.get("/productos/", { params })).data); },
  async saveProduct(item) { return item.id ? api.patch(`/productos/${item.id}/`, item) : api.post("/productos/", item); },
  async services(params) { return listData((await api.get("/servicios/", { params })).data); },
  async saveService(item) { return item.id ? api.patch(`/servicios/${item.id}/`, item) : api.post("/servicios/", item); },
};
